import {chkObject} from "../utils/Utils";
import {cameraState} from "../../state";

const FormatControlsData = (controlsData) => {
  
  /*
    ---------------------------------------------------------------------------
     main controls - hero shots
  */
  
  cameraState.developerControls = controlsData.developerControls;
  
  if (chkObject(controlsData.heroShots)) {
    cameraState.camPositions = controlsData.heroShots;
  }
  
};

export default FormatControlsData;
